import { FC } from 'react';
import { FooterProps } from '../Footer';
import { GettingStartedFooter } from '../../Layouts/GettingStartedLayout/GettingStartedFooter';

export const GettingStartedNoCookingFooter: FC<FooterProps> = props => (
  <GettingStartedFooter {...props} icon="dishes" text="No cooking, no dishes, no cleanup" />
);
